/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

import { reduce } from 'lodash';
import gql from 'graphql-tag';

export default (objectType: string, relevantObjects: []) => {
  const relevantObjectsWithCountSelections = reduce(
    relevantObjects,
    (result: string, item: string) => {
      let objType = item.name.split('.')[1];
      result += `${getRelevantObjectCountFragment(objType)}\n`;
      return result;
    },
    ''
  );

  /**
   * Loops over object types and constructs a relevant query
   * Example:
   * `
   *   relevant {
   *     assessments{totalCount}
   *   	 audits{totalCount}
   *   }
   * }
   * `
   */
  const relevantObjectsFragment = relevantObjectsWithCountSelections
    ? `
      relevant {
        ${relevantObjectsWithCountSelections}
      }
    `
    : ``;

  /**
   * End result query will look like this
   * Example:
   * `
   *   node(id: "Program:13") {
   *      ... on Program {
   *         relevant {
   *              assessments{totalCount}
   *              audits{totalCount}
   *              tasks{totalCount}
   *           }
   *         }
   *       }
   *    }
   * `
   */
  return gql`
    query RelevantObjectsTotalCount($objectId: ID!) {
        node(id: $objectId) {
            ... on ${objectType} {
                ${relevantObjectsFragment}
            }
        }
    }
    `;
};

export function getRelevantObjectCountFragment(relevantObjectType: string): string {
  return `
    ${relevantObjectType} {
      totalCount
    }
  `;
}
